<div class="tabs-scroll-area" [ngClass]="{'with-scrollbar-extra-space':addSpaceForScrollbar}">
    <div class="tab-line side-margins">
        <div class="tabs-container">
            <div class="tab" *ngFor="let tab of tabs" [ngClass]="{'hidden':!tab?.isVisible}">
                <button [disabled]="tab?.isDisabled"
                        [routerLink]="tab.route" routerLinkActive="active"
                        [ngClass]="{'invalid':tab.isInvalid}">
                    {{ tab?.label }}
                </button>
            </div>
        </div>
    </div>
</div>
